import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { LogbookAppState } from '../logbook.reducer';
import * as ObjectActions from '../send-notification-group/send-notification-group.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { IBaseOneResponse } from '../../shared/model/interface/crud-response-interface.model';
import * as AppActions from '../app/actions';
import { ISendNotificationGroupModalData, ISendNotificationMailResponseData } from './send-notification-group.model';
import { SendNotificationGroupService } from './send-notification-group.service';

@Injectable()
export class SendNotificationGroupEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<LogbookAppState>,
    private readonly sendNotificationGroupService: SendNotificationGroupService,
  ) {}

  getSendNotificationGroupModalData = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_SEND_NOTIFICATION_MODAL_DATA),
      switchMap((objectData: ObjectActions.GetSendNotificationModalData) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.sendNotificationGroupService.getSendNotificationGroupModalData(objectData.params).pipe(
          switchMap((response: ISendNotificationGroupModalData) => {
            return of(new ObjectActions.GetSendNotificationModalDataCompleted(response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  sendNotificationData = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.SEND_NOTIFICATION_GROUP_DATA),
      switchMap((objectData: ObjectActions.SendNotificationData) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.sendNotificationGroupService
          .sendMailNotification(objectData.params, objectData.issuerAndReason)
          .pipe(
            switchMap((response: IBaseOneResponse<ISendNotificationMailResponseData>) => {
              return of(new ObjectActions.SendNotificationDataCompleted(response), new AppActions.HideLoader());
            }),
            catchError((errorRes) => {
              return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
            }),
          );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );
}
